import React, { useState, useEffect } from 'react';
import Navigation from './components/Navigation';
import Home from './components/Home';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './App.css';

import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';

function App() {
  const [page, setPage] = useState('home');
  const [contactSource, setContactSource] = useState(null);

  const navigateTo = (target, source = null) => {
    setContactSource(source);
    setPage(target);
  };

  // Scroll to top on page change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [page]);

  return (
    <div className="App d-flex flex-column">
      <Navigation setPage={(p) => navigateTo(p)} />
      {page === 'home' && <Home setPage={(p, s) => navigateTo(p, s)} />}
      {page === 'contact' && <Contact source={contactSource} />}
      {page === 'privacy' && <PrivacyPolicy />}
      {page === 'terms' && <TermsOfService />}
      <Footer setPage={(p) => navigateTo(p)} />
    </div>
  );
}

export default App;
